import { useMediaQuery } from '@mui/material';

export const useIsSmallScreen = () => {
  return (
    useMediaQuery('(max-width: 768px)') ||
    (typeof window !== 'undefined' && window.innerWidth < 768)
  );
};
